// extracted by mini-css-extract-plugin
export var button = "_h5-0";